import { VUE_INSTANCE_NAME } from '../constants';

const vue = window[VUE_INSTANCE_NAME];

export default {
  required(value) {
    return !!value || vue.$t('validation.required');
  },
  email(value) {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || vue.$t('validation.email');
  },
  // max(value, requirement) {
  //   return parseInt(value) <= requirement || vue.$t('validation.max', Array.from(requirement));
  // },
};
